<svelte:options customElement={{
  tag: 'news-release',
  shadow: 'none',
  props: {
    items: { reflect: true, type: 'String' }
  }
}} />

<script>
  import SvgIcon from './SvgIcon.svelte';

  /**
   * NEWS RELEASE ニュースリスト
   * 日付＋タグ複数＋タイトル、区切り線、PDF対応
   * @prop {string} items - JSON配列 '[{"date":"...","tags":["..."],"title":"...","href":"...","pdf":false,"pdfSize":"..."}]'
   */
  export let items = '[]';

  let parsedItems = [];

  $: {
    try {
      parsedItems = typeof items === 'string' ? JSON.parse(items) : (Array.isArray(items) ? items : []);
    } catch (e) {
      console.warn('NewsRelease: Invalid items JSON', e);
      parsedItems = [];
    }
  }
</script>

<ul class="mod-newsList01 rt_bn_news_release">
  {#each parsedItems as item}
    <li class="mod-newsList01__item rt_bn_news_release__item">
      <a href={item.href || '#'} class="mod-newsList01__link rt_bn_news_release__link" target={item.blank ? '_blank' : null} rel={item.blank ? 'noopener noreferrer' : null}>
        <div class="mod-newsList01__meta rt_bn_news_release__meta">
          <time class="mod-newsList01__date rt_bn_news_release__date">{item.date || ''}</time>
          {#if item.tags}
          <div class="mod-newsList01__tags rt_bn_news_release__tags">
            {#if item.tags.corporate}
            <span class="mod-newsList01__tag __corporate rt_bn_news_release__tag">{item.tags.corporate}</span>
            {/if}
            {#if item.tags.category}
            <span class="mod-newsList01__tag rt_bn_news_release__tag">{item.tags.category}</span>
            {/if}
          </div>
          {/if}
        </div>
        <p class="mod-newsList01__title rt_bn_news_release__title">
          <span class="mod-newsList01__title-in">{item.title || ''}</span>
          {#if item.pdf}
            <span class="mod-newsList01__pdf rt_bn_news_release__pdf">
              <SvgIcon name="pdf" size="sm" />
              {#if item.pdfSize}
                <span class="__fileSize rt_bn_news_release__pdf-size">({item.pdfSize})</span>
              {/if}
            </span>
          {/if}
        </p>
      </a>
    </li>
  {/each}
</ul>
